export function createPageUrl(pageName: string) {
    if (pageName === 'Projects') return '/Progetti';
    return '/' + pageName.replace(/ /g, '-');
}